import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import infrasol from '../../../../assets/img/desktop/logo_infrasol.png';
import flecha from '../../../../assets/img/desktop/arrow.svg';
import menuIcon from '../../../../assets/img/movil/boton-menu.svg';
import './CDHeaderV2.css';

function CDHeaderV2() {

    const navigate = useNavigate();
    const location = useLocation();
    const [CDHmostrarmenu, setCDHmostrarmenu] = useState("CDH2-no-mostrar-menu");
    const [CDHflecha, setCDHflecha] = useState("CDH2-flecha-desactivado");
    const [hamburgerMenu, setHamburgerMenu] = useState("CDH2-hamburger-closed");
    const [hamburgerServicios, setHamburgerServicios] = useState("CDH2-hamburger-servicios-closed");
    const [hamburgerFlecha, setHamburgerFlecha] = useState("CDH2-flecha-desactivado");
    const [hideTimeout, setHideTimeout] = useState<NodeJS.Timeout | null>(null);

    // Función para determinar si una ruta está activa
    function isActiveRoute(route: string): boolean {
        const currentPath = location.pathname;
        if (route === "") {
            return currentPath === "/" || currentPath === "";
        }
        return currentPath === `/${route}` || currentPath.startsWith(`/${route}/`);
    }

    // Función para verificar si alguna sub-ruta de servicios está activa
    function isServiciosActive(): boolean {
        const serviciosRoutes = [
            "EndpointProtection",
            "Antispam",
            "SeguridadPerimetral",
            "GestionVulnerabilidades",
            "Infraestructura",
            "Networking",
            "CCTV",
            "Hardware",
            "Microsoft",
            "Helpdesk",
            "MantenimientoIndustrial",
            "ContinuidadElectrica",
            "InfraestructuraElectrica"
        ];
        return serviciosRoutes.some(route => isActiveRoute(route));
    }

    function handleMouseEnter() {
        // Cancelar cualquier timeout de ocultar
        if (hideTimeout) {
            clearTimeout(hideTimeout);
            setHideTimeout(null);
        }
        setCDHmostrarmenu("CDH2-mostrar-menu");
        setCDHflecha("CDH2-flecha-activado");
    }

    function handleMouseLeave() {
        // Agregar un pequeño delay antes de ocultar para permitir que el mouse se mueva al dropdown
        const timeout = setTimeout(() => {
            setCDHmostrarmenu("CDH2-no-mostrar-menu");
            setCDHflecha("CDH2-flecha-desactivado");
        }, 150); // 150ms de delay
        setHideTimeout(timeout);
    }

    function handleDropdownMouseEnter() {
        // Cancelar cualquier timeout de ocultar cuando el mouse entra al dropdown
        if (hideTimeout) {
            clearTimeout(hideTimeout);
            setHideTimeout(null);
        }
        setCDHmostrarmenu("CDH2-mostrar-menu");
        setCDHflecha("CDH2-flecha-activado");
    }

    function handleDropdownMouseLeave() {
        // Ocultar el menú cuando el mouse sale del dropdown
        setCDHmostrarmenu("CDH2-no-mostrar-menu");
        setCDHflecha("CDH2-flecha-desactivado");
    }

    function openHamburgerMenu() {
        if (hamburgerMenu === "CDH2-hamburger-open") {
            setHamburgerMenu("CDH2-hamburger-closed");
        }
        else {
            setHamburgerMenu("CDH2-hamburger-open");
        }
    }

    function openHamburgerServicios() {
        if (hamburgerServicios === "CDH2-hamburger-servicios-open") {
            setHamburgerServicios("CDH2-hamburger-servicios-closed");
            setHamburgerFlecha("CDH2-flecha-desactivado");
        }
        else {
            setHamburgerServicios("CDH2-hamburger-servicios-open");
            setHamburgerFlecha("CDH2-flecha-activado");
        }
    }

    function loadViewDesktop(name: string) {
        navigate("/" + name)
        
        // Cerrar menú hamburguesa si está abierto
        if (hamburgerMenu === "CDH2-hamburger-open") {
            setHamburgerMenu("CDH2-hamburger-closed");
            setHamburgerServicios("CDH2-hamburger-servicios-closed");
            setHamburgerFlecha("CDH2-flecha-desactivado");
        }
    }

    return (
        <header id="CDHeaderV2">
            <div id="CDH2-content">
                <div id="CDH2-content__logo" onClick={() => loadViewDesktop("")}>
                    <img src={infrasol} alt="Infrasol Logo" id="CDH2-logo-img" />
                </div>
                {/* Menú normal - visible solo en desktop */}
                <ul className="CDH2-content__lista CDH2-desktop-menu">
                    <li 
                        className={isActiveRoute("") ? "CDH2-active" : ""}
                        onClick={() => loadViewDesktop("")}
                    >
                        Inicio
                    </li>
                    <li 
                        className={isActiveRoute("Nosotros") ? "CDH2-active" : ""}
                        onClick={() => loadViewDesktop("Nosotros")}
                    >
                        Nosotros
                    </li>
                    <div 
                        id="CDH2-content__lista--menu"
                        className={isServiciosActive() ? "CDH2-servicios-active" : ""}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        <div 
                            id={isServiciosActive() ? "CDH2-flecha-activado" : CDHflecha} 
                            className={isServiciosActive() ? "CDH2-flecha-activado" : ""}
                        >
                            <p>Servicios</p>
                            <img id="img-flechaheader-v2" src={flecha} alt="Option Infrasol SAC" />
                        </div>
                        <div 
                            id={CDHmostrarmenu} 
                            className="CDH2-services-dropdown"
                            onMouseEnter={handleDropdownMouseEnter}
                            onMouseLeave={handleDropdownMouseLeave}
                        >
                            {/* Columna 1: Ciberseguridad */}
                            <div className="CDH2-services-column">
                                <h3 className="CDH2-services-column-title">Ciberseguridad</h3>
                                <ul className="CDH2-services-column-list">
                                    <li onClick={() => loadViewDesktop("EndpointProtection")}>Endpoint Protection</li>
                                    <li onClick={() => loadViewDesktop("Antispam")}>Antispam</li>
                                    <li onClick={() => loadViewDesktop("SeguridadPerimetral")}>Seguridad Perimetral</li>
                                    <li onClick={() => loadViewDesktop("GestionVulnerabilidades")}>Gestión de Vulnerabilidades</li>
                                </ul>
                            </div>
                            
                            {/* Columna 2: Infraestructura TI */}
                            <div className="CDH2-services-column">
                                <h3 className="CDH2-services-column-title">Infraestructura TI</h3>
                                <ul className="CDH2-services-column-list">
                                    <li onClick={() => loadViewDesktop("Infraestructura")}>Soluciones de Infraestructura</li>
                                    <li onClick={() => loadViewDesktop("Networking")}>Soluciones de Networking</li>
                                    <li onClick={() => loadViewDesktop("CCTV")}>CCTV</li>
                                    <li onClick={() => loadViewDesktop("Hardware")}>Hardware</li>
                                    <li onClick={() => loadViewDesktop("Microsoft")}>Licenciamiento Microsoft</li>
                                    <li onClick={() => loadViewDesktop("Helpdesk")}>Gestión de Servicio y Soporte</li>
                                </ul>
                            </div>
                            
                            {/* Columna 3: Soluciones Industriales */}
                            <div className="CDH2-services-column">
                                <h3 className="CDH2-services-column-title">Soluciones Industriales</h3>
                                <ul className="CDH2-services-column-list">
                                    <li onClick={() => loadViewDesktop("MantenimientoIndustrial")}>Mantenimiento de Equipos Eléctricos</li>
                                    <li onClick={() => loadViewDesktop("ContinuidadElectrica")}>Instalación de Baterías</li>
                                    <li onClick={() => loadViewDesktop("ContinuidadElectrica")}>Suministro de Estabilizadores</li>
                                    <li onClick={() => loadViewDesktop("ContinuidadElectrica")}>Suministro de UPS</li>
                                    <li onClick={() => loadViewDesktop("InfraestructuraElectrica")}>Suministro de Transformadores</li>
                                    <li onClick={() => loadViewDesktop("InfraestructuraElectrica")}>Suministro de Tableros Eléctricos</li>
                                    <li onClick={() => loadViewDesktop("InfraestructuraElectrica")}>Instalación de Pozo a Tierra</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <li 
                        className={isActiveRoute("Contacto") ? "CDH2-active" : ""}
                        onClick={() => loadViewDesktop("Contacto")}
                    >
                        Contacto
                    </li>
                    <li 
                        className={isActiveRoute("Helpdesk") ? "CDH2-active" : ""}
                        onClick={() => loadViewDesktop("Helpdesk")}
                    >
                        Mesa de Ayuda
                    </li>
                </ul>
                <div id="CDH2-content__phone">
                    <svg id="CDH2-phone-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 5C3 3.89543 3.89543 3 5 3H8.27924C8.70967 3 9.09181 3.27543 9.22792 3.68377L10.7257 8.17721C10.8831 8.64932 10.6694 9.16531 10.2243 9.38787L7.96701 10.5165C9.06925 12.9612 11.0388 14.9308 13.4835 16.033L14.6121 13.7757C14.8347 13.3306 15.3507 13.1169 15.8228 13.2743L20.3162 14.7721C20.7246 14.9082 21 15.2903 21 15.7208V19C21 20.1046 20.1046 21 19 21H18C9.71573 21 3 14.2843 3 6V5Z" fill="#DDB70F" stroke="#DDB70F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span id="CDH2-phone-text">+51(1) 739-2588</span>
                </div>
                {/* Botón hamburguesa - visible solo en móvil */}
                <img 
                    id="CDH2-hamburger-btn" 
                    className="CDH2-mobile-menu" 
                    src={menuIcon} 
                    alt="Menu - Infrasol SAC" 
                    onClick={openHamburgerMenu}
                />
            </div>
            {/* Menú hamburguesa desplegable - visible solo en móvil */}
            <div id={hamburgerMenu} className="CDH2-mobile-menu">
                <ul className="CDH2-hamburger-lista">
                    <li 
                        className={isActiveRoute("") ? "CDH2-active" : ""}
                        onClick={() => loadViewDesktop("")}
                    >
                        Inicio
                    </li>
                    <li 
                        className={isActiveRoute("Nosotros") ? "CDH2-active" : ""}
                        onClick={() => loadViewDesktop("Nosotros")}
                    >
                        Nosotros
                    </li>
                    <div className="CDH2-hamburger-servicios">
                        <div 
                            onClick={openHamburgerServicios} 
                            id={hamburgerFlecha}
                            className={isServiciosActive() ? "CDH2-flecha-activado" : ""}
                        >
                            <p>Servicios</p>
                            <img id="CDH2-hamburger-flecha" src={flecha} alt="Options - Infrasol SAC"/>
                        </div>
                        <ul id={hamburgerServicios}>
                            {/* Ciberseguridad */}
                            <li className="CDH2-hamburger-section-title">Ciberseguridad</li>
                            <li 
                                className={isActiveRoute("EndpointProtection") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("EndpointProtection")}
                            >
                                Endpoint Protection
                            </li>
                            <li 
                                className={isActiveRoute("Antispam") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("Antispam")}
                            >
                                Antispam
                            </li>
                            <li 
                                className={isActiveRoute("SeguridadPerimetral") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("SeguridadPerimetral")}
                            >
                                Seguridad Perimetral
                            </li>
                            <li 
                                className={isActiveRoute("GestionVulnerabilidades") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("GestionVulnerabilidades")}
                            >
                                Gestión de Vulnerabilidades
                            </li>
                            
                            {/* Infraestructura TI */}
                            <li className="CDH2-hamburger-section-title">Infraestructura TI</li>
                            <li 
                                className={isActiveRoute("Infraestructura") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("Infraestructura")}
                            >
                                Soluciones de Infraestructura
                            </li>
                            <li 
                                className={isActiveRoute("Networking") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("Networking")}
                            >
                                Soluciones de Networking
                            </li>
                            <li 
                                className={isActiveRoute("CCTV") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("CCTV")}
                            >
                                CCTV
                            </li>
                            <li 
                                className={isActiveRoute("Hardware") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("Hardware")}
                            >
                                Hardware
                            </li>
                            <li 
                                className={isActiveRoute("Microsoft") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("Microsoft")}
                            >
                                Licenciamiento Microsoft
                            </li>
                            <li 
                                className={isActiveRoute("Helpdesk") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("Helpdesk")}
                            >
                                Gestión de Servicio y Soporte
                            </li>
                            
                            {/* Soluciones Industriales */}
                            <li className="CDH2-hamburger-section-title">Soluciones Industriales</li>
                            <li 
                                className={isActiveRoute("MantenimientoIndustrial") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("MantenimientoIndustrial")}
                            >
                                Mantenimiento de Equipos Eléctricos
                            </li>
                            <li 
                                className={isActiveRoute("ContinuidadElectrica") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("ContinuidadElectrica")}
                            >
                                Instalación de Baterías
                            </li>
                            <li 
                                className={isActiveRoute("ContinuidadElectrica") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("ContinuidadElectrica")}
                            >
                                Suministro de Estabilizadores
                            </li>
                            <li 
                                className={isActiveRoute("ContinuidadElectrica") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("ContinuidadElectrica")}
                            >
                                Suministro de UPS
                            </li>
                            <li 
                                className={isActiveRoute("InfraestructuraElectrica") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("InfraestructuraElectrica")}
                            >
                                Suministro de Transformadores
                            </li>
                            <li 
                                className={isActiveRoute("InfraestructuraElectrica") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("InfraestructuraElectrica")}
                            >
                                Suministro de Tableros Eléctricos
                            </li>
                            <li 
                                className={isActiveRoute("InfraestructuraElectrica") ? "CDH2-active" : ""}
                                onClick={() => loadViewDesktop("InfraestructuraElectrica")}
                            >
                                Instalación de Pozo a Tierra
                            </li>
                        </ul>
                    </div>
                    <li 
                        className={isActiveRoute("Contacto") ? "CDH2-active" : ""}
                        onClick={() => loadViewDesktop("Contacto")}
                    >
                        Contacto
                    </li>
                    <li 
                        className={isActiveRoute("Helpdesk") ? "CDH2-active" : ""}
                        onClick={() => loadViewDesktop("Helpdesk")}
                    >
                        Mesa de Ayuda
                    </li>
                </ul>
            </div>
        </header>
    );
}

export default CDHeaderV2;

